export enum PriceBreakdownType {
  ALWAYS_SHOW = 'always_show',
  APPLICABLE_COSTS_SEPARATE_TAX = 'applicable_costs_separate_tax',
  APPLICABLE_COSTS_SUBTOTAL_ONLY = 'applicable_costs_subtotal_only',
  DEFAULT = 'default',
  ITEMIZED = 'itemized',
  SEPARATE_TAX = 'separate_tax',
  SUBTOTAL_ONLY = 'subtotal_only',
}
